/**
 * A2UI DateTimeInput Component
 * Date and/or time picker with data binding
 */

import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';

const A2UIDateTimeInput = ({ 
  label,
  value,
  dataBinding,
  mode = 'date', // 'date', 'time', 'datetime'
  min,
  max,
  required = false,
  disabled = false,
  helperText,
  errorText,
  action,
  style,
  resolveValue,
  onDataChange,
  onAction,
  surfaceId,
  componentId
}) => {
  const resolvedLabel = resolveValue ? resolveValue(label, surfaceId) : label?.literalString || '';
  const resolvedValue = resolveValue ? resolveValue(value || dataBinding, surfaceId) : '';
  const resolvedMin = resolveValue ? resolveValue(min, surfaceId) : min?.literalString || '';
  const resolvedMax = resolveValue ? resolveValue(max, surfaceId) : max?.literalString || '';
  const resolvedDisabled = resolveValue ? resolveValue(disabled, surfaceId) : disabled?.literalBoolean || false;
  const resolvedHelper = resolveValue ? resolveValue(helperText, surfaceId) : helperText?.literalString || '';
  const resolvedError = resolveValue ? resolveValue(errorText, surfaceId) : errorText?.literalString || '';
  
  const [localValue, setLocalValue] = useState(resolvedValue || '');

  useEffect(() => {
    setLocalValue(resolvedValue || '');
  }, [resolvedValue]);

  // Determine input type based on mode
  const getInputType = () => {
    switch (mode) {
      case 'time': return 'time';
      case 'datetime': return 'datetime-local';
      case 'date':
      default: return 'date';
    }
  };

  const handleChange = (e) => {
    const newValue = e.target.value;
    setLocalValue(newValue);
    
    if (dataBinding?.path && onDataChange) {
      onDataChange(surfaceId, dataBinding.path, newValue);
    }
  };

  const handleBlur = () => {
    if (action && onAction) {
      onAction({
        name: action.name,
        surfaceId,
        sourceComponentId: componentId,
        context: action.context,
        timestamp: new Date().toISOString()
      });
    }
  };

  return (
    <Form.Group className="a2ui-datetime-input mb-3" style={style}>
      {resolvedLabel && (
        <Form.Label>{resolvedLabel}</Form.Label>
      )}
      <Form.Control
        type={getInputType()}
        value={localValue}
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={resolvedDisabled}
        required={required}
        min={resolvedMin}
        max={resolvedMax}
        isInvalid={!!resolvedError}
      />
      {resolvedError && (
        <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
          {resolvedError}
        </Form.Control.Feedback>
      )}
      {resolvedHelper && !resolvedError && (
        <Form.Text className="text-muted">
          {resolvedHelper}
        </Form.Text>
      )}
    </Form.Group>
  );
};

export default A2UIDateTimeInput;
